<template>
    <div>
      <div class="db-filter-modal">
        <div class="db-filter-title-text">Filter SBUJK</div>
        <div class="db-filter-edit-form">
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Nomor</div>
            <div class="db-filter-hiw-full">
              <input
                type="number"
                class="db-filter-hiw-text"
              />
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Klasifikasi</div>
            <div class="db-filter-hiw-full">
              <input
                type="text"
                class="db-filter-hiw-text"
              />
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Kode</div>
            <div class="db-filter-hiw-full">
              <input
                type="text"
                class="db-filter-hiw-text"
              />
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Sub Klasifikasi</div>
            <div class="db-filter-hiw-full">
              <input
                type="text"
                class="db-filter-hiw-text"
              />
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Kualifikasi</div>
            <div class="db-filter-hiw-multiple">
              <select class="db-filter-hiw-select">
                <option>Kecil</option>
                <option>Menengah</option>
                <option>Tinggi</option>
              </select>
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Last Modified Date</div>
            <div class="db-filter-hiw-date">
              <input
                type="date" class="hd-2-row"
              />
              <input
                type="date" class="hd-2-row"
              />
            </div>
          </div>
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Last Modified By</div>
            <div class="db-filter-hiw-full">
              <input
                type="text"
                class="db-filter-hiw-text"
              />
            </div>
          </div> 
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Catatan</div>
            <div class="db-filter-hiw-full">
              <input
                type="text"
                class="db-filter-hiw-text"
              />
            </div>
          </div>  
          <div class="db-filter-half-input-wrapper">
            <div class="db-filter-hiw-label">Status</div>
            <div class="db-filter-hiw-multiple">
              <select class="db-filter-hiw-select">
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>
          </div>   
        </div>
        <div class="button-container">
          <div class="button-wrapper">
            <div class="email-button" @click="closeModal">CANCEL</div>
            <div class="email-button">CONFIRM</div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
export default{
    methods :{
        closeModal(){
            this.$emit('closeModal')
        }
    }
}
</script>